'use client';

import { cn } from '@holistic/components';
import { Lock } from '@holistic/components/icons';

import type { ComponentType, ReactNode } from 'react';

import FlowCard from '../flow-card';

type CheckoutSectionProps = {
  icon: ComponentType<{ className?: string }>;
  title: string;
  /** Kilitliyken gösterilen açıklama: önce ne tamamlanmalı? */
  lockedText: string;
  isLocked: boolean;
  children: ReactNode;
  bodyClassName?: string;
};

/**
 * Ödeme sayfasındaki kademeli bölüm: bir önceki bölüm tamamlanmadan açılmaz.
 *
 * Adres → randevu → ödeme sırası zorunlu; randevu günleri ilçeye, ödeme de
 * teslimat bilgilerine bağlı olduğu için erken doldurulmaları anlamsız.
 */
const CheckoutSection = ({
  icon,
  title,
  lockedText,
  isLocked,
  children,
  bodyClassName,
}: CheckoutSectionProps) => (
  <FlowCard
    icon={icon}
    title={title}
    className={cn(isLocked && 'border-dashed bg-gray-50/40 shadow-none')}
    bodyClassName={isLocked ? 'p-5' : bodyClassName}
  >
    {isLocked ? (
      <div className="flex items-center gap-3 text-gray-400">
        <span className="flex size-9 shrink-0 items-center justify-center rounded-full bg-gray-100">
          <Lock className="size-4" />
        </span>
        <p className="text-sm leading-relaxed">{lockedText}</p>
      </div>
    ) : (
      <div className="animate-mega-in">{children}</div>
    )}
  </FlowCard>
);

export default CheckoutSection;
